// This file was generated using `pay js:run gql-v1 --type=query --name=V1 --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.
import { useQuery } from '@sail/data';
import { useV1Context } from '../../v1Context';
import mergeContextVariables from '../utils/mergeContextVariables';
export default function useV1Query(query, options) {
    var _options_variables;
    const v1Context = useV1Context();
    const finalOptions = Object.assign({}, options, {
        variables: Object.assign({}, options === null || options === void 0 ? void 0 : options.variables, {
            v1Context: mergeContextVariables(v1Context, options === null || options === void 0 ? void 0 : (_options_variables = options.variables) === null || _options_variables === void 0 ? void 0 : _options_variables.v1Context)
        })
    });
    return useQuery(query, finalOptions);
}

//# sourceMappingURL=useV1Query.js.map